import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { RestEndpoint } from "../../../constants/rest-endpoint.constants";
import { Token } from "../../models/tokens";

@Injectable({
    providedIn: 'root'
})
export class TokensService {

    constructor(
        private readonly http: HttpClient
    ) { }

    public getTokens(): Observable<Array<Token>> {
        return this.http.get(RestEndpoint.getAllTokens, {})
            .pipe(
                map((data: Array<Token>) => {
                    return data;
                }),
                catchError((err) => {
                    throw (err);
                })
            );
    }

    public searchToken(filter: Token): Observable<Array<Token>> {
        return this.http.post(RestEndpoint.searchTokens, filter)
            .pipe(
                map((data: Array<Token>) => {
                    return data;
                }),
                catchError((err) => {
                    throw (err);
                })
            );
    }

    public getTokenById(TokenIdentifier: string): Observable<Token> {
        return this.http.get(RestEndpoint.getToken, { params: { TokenIdentifier } })
            .pipe(
                map((data: Token) => {
                    return data;
                }),
                catchError((err) => {
                    throw (err);
                })
            );
    }

    public deleteToken(id: string): Observable<boolean> {
        const url = RestEndpoint.deleteToken + id;
        return this.http.delete<boolean>(url)
            .pipe(
                catchError((err) => {
                    throw err;

                })
            );
    }


    public saveToken(newParameter: Token): Observable<boolean> {
        return this.http.put<boolean>(RestEndpoint.updateTokens, newParameter)
            .pipe(
                map((updated: boolean) => {
                    return updated;
                }),
                catchError((err) => {
                    throw err;

                })
            );
    }

    public createToken(Token: Token): Observable<boolean> {
        return this.http.post<string>(RestEndpoint.createToken, Token)
            .pipe(
                map((templateId: string) => {
                    if (templateId) {
                        return true;
                    } else {
                        return false;
                    }
                }),
                catchError((err) => {
                    throw err;

                })
            );
    }
}